import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import GenericButton from '../GenericButton/GenericButton';

const SecondaryButton: React.FC<{
	label: string;
	onClick: () => void;
	size?: 'sm' | 'md' | 'lg';
	icon?: IconProp;
	fullWidth?: boolean;
	disabled?: boolean;
	invert?: boolean;
	hideIcon?: boolean;
	forceShowLabel?: boolean;
}> = (props) => <GenericButton {...props} variant="secondary" />;

export default SecondaryButton;
